import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Lock } from "lucide-react";
import { ASSETS } from "../lib/api";
import { formatApiError } from "../lib/api";
import { toast, Toaster } from "sonner";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await login(email, password);
      toast.success("Bine ați revenit!");
      navigate("/admin");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || "Autentificare eșuată");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-warm-gradient p-4">
      <Toaster position="top-center" />
      <div className="w-full max-w-md">
        <div className="text-center mb-6">
          <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-brand-yellow ring-4 ring-brand-yellow/30 shadow-soft overflow-hidden">
            <img src={ASSETS.emblem} alt="" className="w-full h-full object-cover scale-110" draggable={false} />
          </div>
          <h1 className="mt-5 font-display font-extrabold text-brand-navy text-3xl tracking-tight">Panou administrare</h1>
          <p className="mt-1 text-brand-navy/70 text-sm">CMI. Dr. Biriș Cornelia · Ro-Dental Cluj-Napoca</p>
        </div>

        <form onSubmit={submit} className="bg-white rounded-3xl p-7 shadow-soft border border-brand-yellow/40 space-y-4" data-testid="admin-login-form">
          <div className="space-y-2">
            <Label htmlFor="email" className="text-brand-navy font-semibold">Email</Label>
            <Input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="admin-login-email" />
          </div>
          <div className="space-y-2">
            <Label htmlFor="password" className="text-brand-navy font-semibold">Parolă</Label>
            <Input id="password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required data-testid="admin-login-password" />
          </div>
          <Button type="submit" disabled={submitting} className="w-full bg-brand-navy hover:bg-brand-navyDeep text-white py-6 rounded-full font-semibold" data-testid="admin-login-submit">
            <Lock className="w-4 h-4 mr-2" />
            {submitting ? "Se autentifică…" : "Intră în panou"}
          </Button>
        </form>
      </div>
    </div>
  );
}
